import { Box, Loader } from "@braintrust/braintrust-ui-components";

export const UniversalSearchLoader = () => {
  return (
    <Box sx={{ minHeight: "5rem" }}>
      <Loader centered />
    </Box>
  );
};
